@use 'pkg:@ongov/ontario-design-system-global-styles/styles/scss/1-variables/colours.variables' as colours;
@use 'pkg:@ongov/ontario-design-system-global-styles/styles/scss/1-variables/fonts.variables' as fonts;
@use 'pkg:@ongov/ontario-design-system-global-styles/styles/scss/1-variables/spacing.variables' as spacing;
@use 'pkg:@ongov/ontario-design-system-global-styles/styles/scss/1-variables/font-weights.variables' as fontWeights;
@use 'pkg:@ongov/ontario-design-system-global-styles/styles/scss/1-variables/font-sizes.variables' as fontSizes;
@use 'pkg:@ongov/ontario-design-system-global-styles/styles/scss/2-tools/functions/global.functions' as globalFunctions;

.ontario-badge__container {
	display: flex;
	flex-direction: column;
	gap: spacing.$spacing-7;
	align-items: flex-start;
	padding: spacing.$spacing-5 spacing.$spacing-4;
}

.ontario-badge__label {
	display: block;
	text-align: left;
	font-weight: fontWeights.$ontario-font-weights-semi-bold;
	margin-bottom: spacing.$spacing-3;
	font-size: fontSizes.$ontario-font-size-small;
	color: colours.$ontario-greyscale-70;
}

.ontario-badge {
	display: inline-block;
	background-color: colours.$ontario-colour-information-light;
	color: colours.$ontario-greyscale-70;
	padding: spacing.$spacing-1 spacing.$spacing-2;
	font-family: fonts.$ontario-font-raleway-modified;
	font-size: fontSizes.$ontario-font-size-standard-body-text;
	font-weight: fontWeights.$ontario-font-weights-bold;
	line-height: globalFunctions.px-to-rem(25);
	letter-spacing: 0.03rem;
	text-transform: uppercase;
}

.ontario-badge--light-teal {
	background-color: colours.$ontario-colour-information-light;
	color: colours.$ontario-greyscale-70;
}

.ontario-badge--teal {
	background-color: colours.$ontario-colour-information;
	color: colours.$ontario-colour-white;
}

.ontario-badge--grey {
	background-color: colours.$ontario-greyscale-5;
	color: colours.$ontario-greyscale-70;
}

.ontario-badge--black {
	background-color: colours.$ontario-colour-black;
	color: colours.$ontario-colour-white;
}

.ontario-badge--red {
	background-color: colours.$ontario-colour-alert;
	color: colours.$ontario-colour-white;
}

.ontario-badge--yellow {
	background-color: colours.$ontario-colour-warning;
	color: colours.$ontario-colour-black;
}

.ontario-badge--green {
	background-color: colours.$ontario-colour-success;
	color: colours.$ontario-colour-white;
}

.ontario-badge--white {
	background-color: colours.$ontario-colour-white;
	color: colours.$ontario-greyscale-70;
	border: globalFunctions.px-to-rem(1) solid colours.$ontario-greyscale-70;
}

.ontario-badge--dark-grey {
	background-color: colours.$ontario-greyscale-20;
	color: colours.$ontario-colour-black;
}
